import { render, staticRenderFns } from "./c2c3IdentityVerification.vue?vue&type=template&id=0a238a26"
import script from "./c2c3IdentityVerification.vue?vue&type=script&lang=js"
export * from "./c2c3IdentityVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports